import { useAtom } from 'jotai';

import { CountMedalsData, medalsAtom, initialCountMedals } from '@/store';

const useCountMedals = () => {
  const [medalsData, setMedalsData] = useAtom(medalsAtom);

  const handleSetMedalsData = (data: CountMedalsData) => {
    setMedalsData(data);
  };

  const handleResetMedalsData = () => {
    setMedalsData(initialCountMedals);
  };

  return {
    medalsData,
    handleSetMedalsData,
    handleResetMedalsData,
  };
};

export default useCountMedals;
